import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderSlot as _renderSlot, withModifiers as _withModifiers, withKeys as _withKeys } from "vue";
const _hoisted_1 = {
    class: "login-form",
    id: "login-form"
};
const _hoisted_2 = { class: "login-form__title" };
const _hoisted_3 = { class: "alert alert--success" };
const _hoisted_4 = {
    key: 0,
    class: "alert alert--error"
};
const _hoisted_5 = { class: "form__buttons" };
const _hoisted_6 = ["disabled"];
const _hoisted_7 = ["disabled"];
import { onBeforeMount, onMounted, ref } from 'vue';
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import Spinner from '@astina/paloma-common-ui/src/components/Spinner.vue';
import paloma from '@astina/paloma-common-ui/src/services/PalomaBackend';
import ValidationUtils from '@astina/paloma-common-ui/src/services/ValidationUtils';
import trans from '@astina/paloma-common-ui/src/services/Translator';
import TermsAndConditions from "../components/TermsAndConditions.vue";
import TermsAndConditionsAdditional from "../components/TermsAndConditionsAdditional.vue";
import config from "../services/PortalConfig";
import FormValidator from "@astina/paloma-common-ui/src/components/form/FormValidator";
export default /*@__PURE__*/ _defineComponent({
    __name: 'LoginAccessView',
    setup(__props) {
        const { te } = useI18n();
        const route = useRoute();
        const router = useRouter();
        const accessRequestsEnabled = ref(config.accessRequestsEnabled);
        onBeforeMount(() => {
            if (!accessRequestsEnabled.value) {
                router.push({ path: 'home' });
            }
        });
        const form = createForm();
        const submitted = ref(false);
        const loading = ref(false);
        const error = ref(false);
        const success = ref(false);
        const validation = ref({ errors: [], fields: {} });
        const accessRequest = ref({
            company: null,
            firstName: null,
            lastName: null,
            phoneNumber: null,
            emailAddress: null,
            customerNumber: null,
            street: null,
            zipCode: null,
            city: null,
            // if no translation is defined for 'terms.accept', the checkbox + text are not shown
            acceptTerms: !te('terms.accept')
        });
        onMounted(() => {
            // @ts-ignore
            const customerNumber = route.query.customerNumber;
            if (customerNumber) {
                accessRequest.value.customerNumber = customerNumber;
            }
            // @ts-ignore
            const token = route.query.token;
            if (token) {
                router.push({ name: 'login_reset_password', query: { token: token, invite: "true" } });
            }
        });
        function onEnter(event) {
            // enter inside textarea should not submit form
            // @ts-ignore
            if (event.target && 'TEXTAREA' === event.target.nodeName) {
                return;
            }
            submit();
        }
        function submit() {
            submitted.value = true;
            const val = FormValidator.validate(form.fields, accessRequest.value);
            const isValid = FormValidator.isValid(val);
            if (!accessRequest.value.acceptTerms || !isValid) {
                return;
            }
            error.value = false;
            loading.value = true;
            if (accessRequest.value.customerNumber) {
                accessRequest.value.existingCustomerDto = {
                    customerNumber: accessRequest.value.customerNumber,
                };
            }
            accessRequest.value.newCustomerDto = {
                street: accessRequest.value.street,
                zipCode: accessRequest.value.zipCode,
                city: accessRequest.value.city,
            };
            paloma
                .execute('customers.request_access', accessRequest.value)
                .then(() => {
                success.value = true;
            })
                .catch((error) => {
                const val = ValidationUtils.createValidation(error, 'login.request-access');
                if (val === error) {
                    error.value = true;
                }
                else {
                    validation.value = val;
                }
            })
                .finally(() => loading.value = false);
        }
        function cancel() {
            router.push({ name: 'login_form' });
        }
        function createForm() {
            return {
                name: 'access_request',
                fields: [
                    {
                        name: 'company',
                        label: trans('login.request-access-company'),
                        type: 'text',
                        options: {
                            required: true,
                        },
                    },
                    {
                        name: 'firstName',
                        label: trans('login.request-access-firstName'),
                        type: 'text',
                        options: {
                            required: true,
                        },
                    },
                    {
                        name: 'lastName',
                        label: trans('login.request-access-lastName'),
                        type: 'text',
                        options: {
                            required: true,
                        },
                    },
                    {
                        name: 'street',
                        label: trans('login.request-access-street'),
                        type: 'text',
                        options: {
                            required: true,
                        },
                    },
                    {
                        name: 'zipCode',
                        label: trans('login.request-access-zipCode'),
                        type: 'text',
                        options: {
                            required: true,
                        },
                    },
                    {
                        name: 'city',
                        label: trans('login.request-access-city'),
                        type: 'text',
                        options: {
                            required: true,
                        },
                    },
                    {
                        name: 'emailAddress',
                        label: trans('login.email'),
                        type: 'email',
                        options: {
                            required: true,
                        },
                    },
                    {
                        name: 'phoneNumber',
                        label: trans('login.request-access-phoneNumber'),
                        type: 'text',
                        options: {
                            required: true,
                        },
                    },
                    {
                        name: 'customerNumber',
                        label: trans('login.request-access-customerNumber-optional'),
                        type: 'text',
                        options: {
                            required: false,
                            ...(trans('login.request-access-customerNumber-optional-description') !== 'login.request-access-customerNumber-optional-description' && {
                                help: trans('login.request-access-customerNumber-optional-description'),
                            }),
                        },
                    },
                ],
            };
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            const _component_form_fields = _resolveComponent("form-fields");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('login.request-access')), 1),
                _cache[7] || (_cache[7] = _createTextVNode()),
                (success.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('login.request-access-success')), 1),
                        _cache[1] || (_cache[1] = _createTextVNode()),
                        _createElementVNode("p", null, [
                            _createVNode(_component_router_link, {
                                to: { name: 'login_form' },
                                class: "button button--link button--cancel"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('back')), 1)
                                ]),
                                _: 1
                            })
                        ])
                    ], 64))
                    : (_openBlock(), _createElementBlock("form", {
                        key: 1,
                        onSubmit: _withModifiers(submit, ["prevent"]),
                        onKeyup: _withKeys(onEnter, ["enter"]),
                        class: "form form--simple",
                        novalidate: ""
                    }, [
                        (error.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('login.request-access-error')), 1))
                            : _createCommentVNode("", true),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        _createVNode(_component_form_fields, {
                            form: _unref(form),
                            fields: _unref(form).fields,
                            data: accessRequest.value,
                            validation: validation.value,
                            submitted: submitted.value,
                            disabled: loading.value
                        }, null, 8, ["form", "fields", "data", "validation", "submitted", "disabled"]),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createVNode(TermsAndConditions, {
                            modelValue: accessRequest.value.acceptTerms,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((accessRequest.value.acceptTerms) = $event)),
                            submitted: submitted.value
                        }, null, 8, ["modelValue", "submitted"]),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        _renderSlot(_ctx.$slots, "default", { id: "buttons" }, () => [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("button", {
                                    type: "submit",
                                    class: "button button--primary",
                                    disabled: loading.value
                                }, [
                                    _createVNode(Spinner, { loading: loading.value }, null, 8, ["loading"]),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('login.request-access')), 1)
                                ], 8, _hoisted_6),
                                _cache[2] || (_cache[2] = _createTextVNode()),
                                _createElementVNode("a", {
                                    onClick: _withModifiers(cancel, ["prevent"]),
                                    class: "button button--link button--cancel",
                                    disabled: loading.value,
                                    href: ""
                                }, _toDisplayString(_ctx.$t('back')), 9, _hoisted_7)
                            ])
                        ]),
                        _cache[6] || (_cache[6] = _createTextVNode()),
                        _createVNode(TermsAndConditionsAdditional)
                    ], 32))
            ]));
        };
    }
});
